import { ConsentCategoryDefinition, ConsentPreferences } from "./types";

export const CONSENT_STORAGE_KEY = "eckenmoorhexen.consent.v1";
export const CONSENT_STORAGE_VERSION = 1;
export const CONSENT_OPEN_PREFERENCES_EVENT = "eckenmoorhexen:open-cookie-settings";

export const consentCategories: ConsentCategoryDefinition[] = [
  {
    key: "essential",
    title: "Essenziell",
    description:
      "Diese Technologien sind fuer den sicheren Betrieb, die Navigation, die Speicherung deiner Consent-Entscheidung und andere technisch zwingend erforderliche Funktionen notwendig. Eine Einwilligung ist hier nur insoweit entbehrlich, wie die Nutzung unbedingt erforderlich ist.",
    requiresConsent: false,
    alwaysActive: true,
  },
  {
    key: "statistics",
    title: "Statistik / Analyse",
    description:
      "Diese Technologien helfen uns, Reichweite und Nutzung der Website auszuwerten. Sie werden erst nach deiner ausdruecklichen Einwilligung geladen und duerfen ohne Opt-in nicht aktiv sein.",
    requiresConsent: true,
  },
  {
    key: "marketing",
    title: "Marketing",
    description:
      "Marketing-Technologien dienen dazu, Kampagnen zu messen und personalisierte Werbung auszuspielen. Sie setzen eine vorherige ausdrueckliche Einwilligung voraus.",
    requiresConsent: true,
  },
  {
    key: "external_media",
    title: "Externe Medien",
    description:
      "Darunter fallen eingebettete Videos, Karten, Social-Media-Inhalte oder andere externe Medien. Solche Inhalte werden erst nach deiner Einwilligung geladen, weil dabei Informationen auf deinem Endgeraet gespeichert oder ausgelesen werden koennen.",
    requiresConsent: true,
  },
  {
    key: "comfort",
    title: "Komfort / Praeferenzen",
    description:
      "Komfortfunktionen speichern zusaetzliche Einstellungen, um Inhalte angenehmer bereitzustellen. Sie sind nicht technisch zwingend erforderlich und bleiben standardmaessig deaktiviert.",
    requiresConsent: true,
  },
];

export const defaultConsentPreferences: ConsentPreferences = {
  essential: true,
  statistics: false,
  marketing: false,
  external_media: false,
  comfort: false,
};
